function TyreFilter(properties, filter) {
  this.label = properties.label;
  this.id = properties.id;
  this._presence = properties.presence;
  this._active = properties.active || false;
  this._filter = filter;
}

Object.assign(TyreFilter.prototype, {
  setGroup: function (group) {
    this._group = group;
  },

  presence: function (tyres) {
    if (typeof this._presence !== 'function') return false;
    return this._presence(tyres);
  },

  isPresent: function () {
    return this.presence(this._group.tyres());
  },

  applyTo: function (tyres) {
    if (typeof this._filter !== 'function') return tyres;
    return this._filter.call(this, tyres);
  },

  isActive: function () {
    return this._active === true;
  },

  activate: function () {
    this._active = true;
  },

  deactivate: function () {
    this._active = false;
  },

  toString: function () {
    let string = '';
    if (this._group) string = this._group.name;
    string += '-' + this.id;
    return string;
  },

  count: function () {
    return this.applyTo(this._group.applyOthers()).length;
  },
});

export default TyreFilter;
